var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"placeholder":_vm.placeholder,"clearable":"","remote":"","multiple":_vm.multiple,"remote-method":_vm.remoteMethod,"loading":_vm.loading,"size":_vm.size,"filterable":""},on:{"change":_vm.valChange},model:{value:(_vm.userId),callback:function ($$v) {_vm.userId=$$v},expression:"userId"}},_vm._l((_vm.employees),function(item){return _c('el-option',{key:item.userId,attrs:{"label":item.name,"value":item.userId}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3561e5c","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmployeeSelector/index.vue
// module id = 326
// module chunks = 0